/**
 * @file
 * Example of a custom script file.
 */

(function ($, Drupal) {
    Drupal.behaviors.GDSSubthemeGlobal = {
        attach: function (context, settings) {
            setTimeout(function () {
                $("footer div.gds-footer__logo-bi img").removeClass("lazyloaded");
                $("footer div.gds-footer__logo-bi img").removeClass("lazyload");
            }, 2000);
            setTimeout(function () {
                // Removed lazyloaded class from footer logo
                $("footer div.gds-footer__logo-bi img").removeClass("lazyloaded");

                // Add alt attr to Header main logo for print logo header
                $(".print-logo-holder .gds-image img").attr(
                    "alt",
                    $(".print-logo-holder .gds-image img").attr("title")
                );

                // Internal URLs → target="_self"
                $("a.skip-disclaimer").attr("target", "_self");

                // External URLs → target="_blank"
                $("a.display-disclaimer").attr("target", "_blank");

                // Add rel="noopener" to links with targets
                $("a[target='_self'], a[target='_blank']").attr("rel", "noopener");

                // Adding Tiltle for Footer Logo
                $(".gds-footer__logo-bi .gds-logo, .gds-footer__logo-bi img").attr(
                    "title",
                    "Boehringer Ingelheim Logo"
                );

                // Adding Tiltle for Disclaimer popup
                $(".gds-modal__actions.form-actions .dialog-cancel").attr("title", $(".gds-modal__actions.form-actions .dialog-cancel").attr("alt"));
                $(".gds-modal__actions.form-actions .external-confirm").attr("title", $(".gds-modal__actions.form-actions .external-confirm").attr("aria-label"));
            })

            // Set width and height attribute on header bi logo
            $('#block-cardiorenalmetabolicmap-pro-mainheader a.gds-logo img').each(function () {
                $(this).attr({
                    width: 160,
                    height: 80
                });
            });
        }
    }
})(jQuery, Drupal);